import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=66d76bcc&scoped=true"
import script from "./Academy.vue?vue&type=script&lang=js"
export * from "./Academy.vue?vue&type=script&lang=js"
import style0 from "./Academy.vue?vue&type=style&index=0&id=66d76bcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d76bcc",
  null
  
)

export default component.exports